import { css } from '@emotion/react'
import {
  Theme,
  Color,
  Shadow,
  ShadowElevation,
  Typography,
  Size,
} from '@opallabs/gem'

export const radixPopoverAnchorWidthVar = '--radix-popper-anchor-width'

export const baseStyles = (theme: Theme) =>
  css({
    backgroundColor: Color[theme].Surface.N000,
    ...Shadow[ShadowElevation.E2],
    ...Typography.T500,
    borderRadius: Size.Rounding,
  })
